module.exports = __webpack_public_path__ + "05be58620816631fa3e10a4ecfbb0116.svg";